import { render, staticRenderFns } from "./blog-detalis.vue?vue&type=template&id=1bbdf2ef&scoped=true&"
import script from "./blog-detalis.vue?vue&type=script&lang=js&"
export * from "./blog-detalis.vue?vue&type=script&lang=js&"
import style0 from "./blog-detalis.vue?vue&type=style&index=0&lang=css&"
import style1 from "./blog-detalis.vue?vue&type=style&index=1&id=1bbdf2ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbdf2ef",
  null
  
)

export default component.exports